import React, { useState, useEffect } from "react";
import API from "../axios";
import { Col, Container, Row } from "react-bootstrap";

const SpcesRatingCategories = () => {
    const [loading, setLoading] = useState(false);
    const [categories, setCategories] = useState([]);

    const loadExpectedResults = async function () {
        setLoading(true);

        const result: any = await API.getExpectedResults();
        setCategories(result.data);

        setLoading(false);
    };

    useEffect(() => {
        loadExpectedResults();
    }, []);

    return (
        <div>
            <Container style={{ marginTop: 100 }}>
                <Row>
                    <Col
                        cols="6"
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            alignItems: "center",
                            gap: 10,
                        }}
                    >
                        <a
                            type="button"
                            className="btn btn-outline-black btn-md mx-1"
                            href={`/`}
                        >
                            <i className="bi bi-chevron-left"></i>
                        </a>
                        <h5 className="h5">Select Main Categories</h5>
                    </Col>
                </Row>
                {loading ? (
                    <div className="d-flex justify-content-center my-5">
                        <div className="spinner-border" role="status">
                            <span className="visually-hidden">Loading...</span>
                        </div>
                    </div>
                ) : (
                    <table className="table table-striped mt-3">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col">Key</th>
                                <th scope="col">Structure</th>
                                <th scope="col">Edit</th>
                            </tr>
                        </thead>
                        <tbody>
                            {categories.map((result: any, index: number) => (
                                <tr key={index}>
                                    <td>{result.name}</td>
                                    <td>{result.key}</td>
                                    <td>
                                        {Object.keys(result.json).length} Fields
                                    </td>
                                    <td>
                                        <div className="d-grid gap-2 d-md-block">
                                            <a
                                                type="button"
                                                className="btn btn-outline-primary btn-sm mx-1"
                                                href={`/specs-rating/${result._id}`}
                                            >
                                                <i className="bi bi-pencil"></i>
                                            </a>
                                        </div>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                )}
            </Container>
        </div>
    );
};

export default SpcesRatingCategories;
